module.exports = __webpack_public_path__ + "img/cv.cvfe0c561.svg";